import React, { useEffect, useState } from 'react'; // Import useEffect and useState
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from 'react-router-dom';
import axios from "axios";
import {useSelector} from "react-redux";

export const OpayoCancel = () => {
    const navigate = useNavigate();
    const { tidParam } = useParams();
    const [tid, setTid] = useState(null);
    const apiURL = useSelector(state => state.mopriSettings.mopriAPIURL);

    useEffect(() => {
        if (tidParam) {
            const tid = tidParam ? tidParam.split('=')[1] : null;
            setTid(tid);
        }
    }, [tidParam]);

    useEffect(() => {
        if (tid) {
            cancelOpayoTransaction()
        }
    }, [tid])

    const cancelOpayoTransaction = async () => {
        const response = await axios.post(`${apiURL}/api/gateway/cancel-opayo-payment`, {
            tid: tid,
        })
        console.log(response)
        if (response.statusText === 'OK') {
            //console.log(response)
        }
    }

    const goBack = () => {
        navigate('/topup');
    };

    return (
        <div className="grid justify-content-center align-items-center bg-orange-100">
            <div className="col-12 md:col-6 lg:col-6">
                <Card
                    className="shadow-2 surface-card"
                    title={
                        <div className="flex align-items-center" style={{ color: 'orange' }}>
                            <FontAwesomeIcon icon={faBan} className="mr-2 text-orange-500 text-2xl" />
                            <span className="text-xl font-semibold">Payment Cancelled</span>
                        </div>
                    }
                >
                    <div className="mb-4">
                        <img
                            src="/img/opayo.png"
                            alt={"Opayo"}
                            style={{
                                height: '60px',
                                width: 'auto',
                            }}
                        />
                        <p className="mt-2 text-lg text-gray-700">
                            Your payment was cancelled.
                        </p>
                        <p className="mt-2 text-lg text-gray-700">
                            Your balance has not been updated.
                        </p>
                    </div>
                    <div className="mb-4 text-gray-600">
                        <p>If you did not intend to cancel, please try again.</p>
                    </div>
                    <div className="flex justify-content-end">
                        <Button label="Try Again" icon="pi pi-refresh" className="p-button-warning" onClick={goBack} />
                    </div>
                </Card>
            </div>
        </div>
    );
};